var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1979 21.7518V16.7518H17.1979V21.7518C17.1979 22.3018 17.6479 22.7518 18.1979 22.7518H21.1979C21.7479 22.7518 22.1979 22.3018 22.1979 21.7518V14.7518H23.8979C24.3579 14.7518 24.5779 14.1818 24.2279 13.8818L15.8679 6.3518C15.4879 6.0118 14.9079 6.0118 14.5279 6.3518L6.16785 13.8818C5.82785 14.1818 6.03785 14.7518 6.49785 14.7518H8.19785V21.7518C8.19785 22.3018 8.64785 22.7518 9.19785 22.7518H12.1979C12.7479 22.7518 13.1979 22.3018 13.1979 21.7518Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.498aca8352a3afce478b0e83f86308ad.svg";
export { ForwardRef as ReactComponent };